import { lazy } from "react";

const RELOAD_FLAG = "chunkReloadAttempted";

// A tab opened before a deploy still asks for the old build's chunk files, which
// the new container no longer has. Reload once to pick up the new build instead
// of leaving a blank page; the flag stops a reload loop if the chunk is really gone.
export const lazyPage = (load) =>
  lazy(() =>
    load()
      .then((module) => {
        sessionStorage.removeItem(RELOAD_FLAG);
        return module;
      })
      .catch((error) => {
        if (sessionStorage.getItem(RELOAD_FLAG)) {
          throw error;
        }
        sessionStorage.setItem(RELOAD_FLAG, "1");
        window.location.reload();
        return new Promise(() => {});
      })
  );
